import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { DividerModule } from '@ui-components/components/divider/divider.module';
import { InputErrorModule } from '@ui-components/components/input-error/input-error.module';
import { SelectTreeModule } from '@ui-components/components/select-tree/select-tree.module';
import { InputModule } from '@ui-components/controls/input/input.module';
import { PhoneNumberInputComponent } from '@ui-components/controls/phone-number-input/phone-number-input.component';
import { RadioButtonDropdownModule } from '@ui-components/controls/radio-button-dropdown/radio-button-dropdown.module';

import { AddVendorModalComponent } from './add-vendor-modal.component';

@NgModule({
  declarations: [AddVendorModalComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    InputModule,
    ReactiveFormsModule,
    RadioButtonDropdownModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    DividerModule,
    SelectTreeModule,
    PhoneNumberInputComponent,
    InputErrorModule,
    MatCheckboxModule,
  ],
  exports: [AddVendorModalComponent],
})
export class AddVendorModalModule {}
